import React, { Component } from 'react'
import '../../../App.css'
import { Layout, Button, Icon, Carousel, Anchor } from 'antd'
import 'animate.css'
import './index.css'
import banner01 from '../../../assets/images/banner/1.png'
import banner02 from '../../../assets/images/banner/2.png'
import banner03 from '../../../assets/images/banner/3.png'
import { withTranslation } from 'react-i18next'
import i18n from 'i18next'
import { exeDownUrl, zhupyDownUrl } from '../../../utils/config'

const { Link } = Anchor
const { Content } = Layout
const downloadZhupy = () => {
  let url = window.location.host
  if (zhupyDownUrl[url]) {
    window.location.href = zhupyDownUrl[url]
  } else {
    window.location.href =
      'https://es-repo.digiwincloud.com.cn/installer/Esclient/EsCloudIstall.zip' //'http://es-update.digiwincloud.com.cn/installer/Esclient/EsCloudIstall.zip'
  }
}
const hrefClick = (e, link) => {
  e.preventDefault()
}
class Contentext extends Component {
  constructor(props) {
    super(props)
    this.handleScroll = this.handleScroll.bind(this)
    this.state = {
      isAnimation01: true,
      isAnimation02: true,
      isAnimation03: true,
    }
  }
  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll)
  }
  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll)
  }
  handleScroll(e) {
    let divHeight = document.getElementById('test').offsetTop
    let divHeight2 = document.getElementById('test2').offsetTop
    let divHeight3 = document.getElementById('test3').offsetTop
    let scrollTop = document.documentElement.scrollTop
    //当显示时开始动画
    //当隐藏时结束动画
    if (divHeight - scrollTop > -171 && divHeight - scrollTop < 728) {
      this.setState({
        isAnimation01: true,
      })
    } else {
      this.setState({
        isAnimation01: false,
      })
    }
    if (divHeight2 - scrollTop > -150 && divHeight2 - scrollTop < 750) {
      this.setState({
        isAnimation02: true,
      })
    } else {
      this.setState({
        isAnimation02: false,
      })
    }
    if (divHeight3 - scrollTop > -520 && divHeight3 - scrollTop < 150) {
      this.setState({
        isAnimation03: true,
      })
    } else {
      this.setState({
        isAnimation03: false,
      })
    }
  }
  downloadExe = () => {
    // let url = window.location.host;
    // if(exeDownUrl[url]){
    //     window.location.href = exeDownUrl[url]
    // }else{
    //     window.location.href = 'http://es-update.digiwincloud.com.cn/installer/SCP.Desktop.Setup.exe'
    // }
    this.props.history.push({ pathname: '/productDownload' })
  }
  render() {
    const { t } = this.props
    const Tools = (props) => {
      if (props.language === 'zhTW') {
        return null
      }
      return (
        <div className="q-main-content pr" id="test4">
          <div className="q-main-content_detail q-content_bg04 pa">
            <p
              className={[
                'pa q-content-box_headline',
                this.state.isAnimation02 ? 'testDiw' : null,
              ].join(' ')}
            >
              {t('tools')}
            </p>
            <div
              className={[
                'pa q-content-box_text',
                this.state.isAnimation02 ? 'testDiw' : null,
              ].join(' ')}
            >
              {t('toolsText')}
            </div>
          </div>
        </div>
      )
    }
    return (
      <Content className="q-content-wrapper">
        <div className="q-banner tc pr">
          <div className="q-banner-d pa">
            <h1>{t('title')}</h1>
            <h3>{t('title_detail')}</h3>
            {/* <div className="button-group">
                            <Button type="define-button" size="large" onClick={this.downloadExe}>
                                <Icon type="download" className="f26" />
                                {t('button_download_cloud')}
                            </Button>
                            <Button  type="define-button-primary" size="large" style={{ display:'none' }}   onClick={downloadZhupy}>
                                {t('button_download_zhupy')}
                            </Button>
                        </div> */}
            <p className="q-banner-text">
              <span className="icon icon-computer"></span>
              {t('title_intro')}
            </p>
          </div>
          <Carousel autoplay className="banner-auto">
            <div>
              <img src={banner01} alt="" />
            </div>
            <div>
              <img src={banner02} alt="" />
            </div>
            <div>
              <img src={banner03} alt="" />
            </div>
          </Carousel>
          <div className="banner-list">
            <div className="q-fix-width ">
              <ul className="banner-list-ul">
                <li className="banner-list-li">
                  <dl className="banner-list-li_item">
                    <dt>
                      <span className="banner-list-icon banner-list-icon01"></span>
                    </dt>
                    <dd>
                      <p>{t('banner_list_item0101')}</p>
                      <p>{t('banner_list_item0102')}</p>
                    </dd>
                  </dl>
                </li>
                <li className="border-line"></li>
                <li className="banner-list-li">
                  <dl className="banner-list-li_item">
                    <dt>
                      <span className="banner-list-icon banner-list-icon02"></span>
                    </dt>
                    <dd>
                      <p>{t('banner_list_item0201')}</p>
                      <p>{t('banner_list_item0202')}</p>
                    </dd>
                  </dl>
                </li>
                <li className="border-line"></li>
                <li className="banner-list-li">
                  <dl className="banner-list-li_item">
                    <dt>
                      <span className="banner-list-icon banner-list-icon03"></span>
                    </dt>
                    <dd>
                      <p>{t('banner_list_item0301')}</p>
                      <p>{t('banner_list_item0302')}</p>
                    </dd>
                  </dl>
                </li>
                <li className="border-line"></li>
                <li className="banner-list-li">
                  <dl className="banner-list-li_item">
                    <dt>
                      <span className="banner-list-icon banner-list-icon04"></span>
                    </dt>
                    <dd>
                      <p>{t('banner_list_item0401')}</p>
                      <p>{t('banner_list_item0402')}</p>
                    </dd>
                  </dl>
                </li>
                <li className="border-line"></li>
                <li className="banner-list-li">
                  <dl className="banner-list-li_item">
                    <dt>
                      <span className="banner-list-icon banner-list-icon05"></span>
                    </dt>
                    <dd>
                      <p>{t('banner_list_item0501')}</p>
                      <p>{t('banner_list_item0502')}</p>
                    </dd>
                  </dl>
                </li>
                <li className="border-line"></li>
                <li className="banner-list-li">
                  <Anchor
                    affix={false}
                    className="href-link"
                    onClick={hrefClick}
                  >
                    <Link href="#api" title={t('more')}></Link>
                    <Icon
                      type="right-circle-o"
                      className="f23"
                      style={{ marginLeft: '10px', verticalAlign: 'middle' }}
                    />
                  </Anchor>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div
          className="q-main"
          style={{ paddingTop: '10px', paddingBottom: '10px' }}
        >
          <div className="q-fix-width" style={{ padding: '0 100px' }}>
            <div className={['q-main-content pr']} id="test">
              <div className={['q-main-content_detail q-content_bg01 pa']}>
                <p
                  className={[
                    'pa q-content-box_headline',
                    this.state.isAnimation01 ? 'testDiw' : null,
                  ].join(' ')}
                >
                  {t('service')}
                </p>
                <div
                  className={[
                    'pa q-content-box_text',
                    this.state.isAnimation01 ? 'testDiw' : null,
                  ].join(' ')}
                >
                  {t('serviceText')}
                </div>
              </div>
            </div>
            <div className={['q-main-content pr']}>
              <div className="q-main-content_detail q-content_bg02 pa">
                <p
                  className={[
                    'pa q-content-box_headline',
                    this.state.isAnimation01 ? 'testDiw' : null,
                  ].join(' ')}
                >
                  {t('submit')}
                </p>
                <div
                  className={[
                    'pa q-content-box_text',
                    this.state.isAnimation01 ? 'testDiw' : null,
                  ].join(' ')}
                >
                  {t('submitText')}
                </div>
              </div>
            </div>
            <div className="q-main-content pr" id="test2">
              <div className="q-main-content_detail q-content_bg03 pa">
                <p
                  className={[
                    'pa q-content-box_headline',
                    this.state.isAnimation02 ? 'testDiw' : null,
                  ].join(' ')}
                >
                  {t('remote')}
                </p>
                <div
                  className={[
                    'pa q-content-box_text',
                    this.state.isAnimation02 ? 'testDiw' : null,
                  ].join(' ')}
                >
                  {t('remoteText')}
                </div>
              </div>
            </div>
            <div className="q-main-content pr" id="test3">
              <div className="q-main-content_detail q-content_bg05 pa">
                <p
                  className={[
                    'pa q-content-box_headline',
                    this.state.isAnimation03 ? 'testDiw' : null,
                  ].join(' ')}
                >
                  {t('knowledge')}
                </p>
                <div
                  className={[
                    'pa q-content-box_text',
                    this.state.isAnimation03 ? 'testDiw' : null,
                  ].join(' ')}
                >
                  {t('knowledgeText')}
                </div>
              </div>
            </div>
            <Tools language={i18n.language} />
          </div>
        </div>
        <div className="q-attach bg-f2f2f2" id="api">
          <div className="q-fix-width tc">
            <h3 className="q-attach-more">{t('more')}</h3>
            <p style={{ width: '45%', margin: '0 auto' }}>{t('detail')}</p>
            <ul className="q-attach-point">
              <li className="">
                <div className="q-preview">
                  <span className="icon icon-home-ser icon-service-apply "></span>
                </div>
                <h4>{t('item01')}</h4>
              </li>
              <li>
                <div className="q-preview">
                  <span className="icon icon-home-ser icon-notify-center"></span>
                </div>
                <h4>{t('item02')}</h4>
              </li>
              <li>
                <div className="q-preview">
                  <span className="icon icon-home-ser icon-intelligent-oper"></span>
                </div>
                <h4>{t('item03')}</h4>
              </li>
              <li>
                <div className="q-preview">
                  <span className="icon icon-home-ser icon-community"></span>
                </div>
                <h4>{t('item04')}</h4>
              </li>
            </ul>
          </div>
        </div>
      </Content>
    )
  }
}
export default withTranslation()(Contentext)
